import DefaultTheme from "styled-components";

export const theme = {
	...DefaultTheme,
	breakpoints: {
		xs: "376px",
		sm: "576px",
		md: "786px",
		lg: "992px",
		xl: "1200px",
		xxl: "1400px",
	},
};
